import { COLORS, BOX_SHADOWS } from 'constants/index';
import typography from 'theme/typography';

const MuiAutocomplete = {
  inputRoot: {
    '&[class*="MuiFilledInput-root"]': {
      paddingTop: '9px',
      paddingLeft: '16px',
      paddingBottom: '5px',

      '& $input': {
        ...typography.body2,
        paddingLeft: '0',
        paddingRight: '0',
        paddingTop: '16px',
        paddingBottom: '4px',
        marginTop: '0',
        borderRadius: '4px !important',
      }
    },
  },
  paper: {
    boxShadow: BOX_SHADOWS.card,
    margin: '8px 0',
    backgroundColor: COLORS.WHITE,
  },
  option: {
    '&:hover': {
      backgroundColor: COLORS.GRAY_08,
    }
  }
};

export default MuiAutocomplete;